// BookShelf.js
import Gif from "./Gif";
import Highlights from "./Highlights";
const BookShelf = () => (
    <div>
        <h2>What I've been reading</h2>
          <Highlights/>
          <Gif/>
    </div>
  );
  
  export default BookShelf;
  

